<template>
  <PoppinsCareTypeCardGroup
    :careTypes="sitterCareTypes"
    :headingText="headingText"
    :subheadingText="subheadingText"
    @select="handleSelect"
  />
</template>

<script lang="ts">
import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import { mapGetters } from 'vuex';
import { sendSegmentEvent } from '@/lib/segment';
import { CareType } from '@/types/care_type';
import CareTypeCardGroup from '@/components/careType/CareTypeCardGroup.vue';

export default {
  name: 'SitterCareType',
  components: {
    PoppinsCareTypeCardGroup: CareTypeCardGroup,
  },
  data(): {
    headingText: string;
    subheadingText: string;
    selectedCareType: string;
  } {
    return {
      headingText: 'What kinds of jobs are you looking for?',
      subheadingText: `Don't worry - you can always create additional profiles once you've registered`,
      selectedCareType: '',
    };
  },
  computed: {
    ...mapGetters(['sitterCareTypes' as CareType]),
  },
  methods: {
    async handleSelect(careType) {
      await this.$store.dispatch('setCareType', camelCase(careType));
      this.providerTypeSelected(careType);
      this.handleRedirect(kebabCase(careType));
    },
    handleRedirect(careType) {
      const isChildCare = ['babysitter', 'nanny'].includes(careType);
      const targetPath = isChildCare ? '/sitter/signup/profile/steps' : `/sitter/signup/profile/${careType}`;

      this.$router.push({ path: targetPath });
    },
    providerTypeSelected(careType) {
      sendSegmentEvent('Profile - Care Type Selected', {
        provider_type: careType,
      });
    },
  },
};
</script>
